/* eslint-disable import/prefer-default-export */
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import format from 'date-fns/format';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const getUserData = (user, condominium) => {
  if (user && user.condominiums) {
    const userData = user.condominiums.find(x => x.data === condominium._id);

    if (userData && userData.role === 'janitor') userData.unity = 'Síndico';
    return userData;
  }
  return false;
};

export const generateVotesPDF = ({ assembly, condominium, me }) => {
  const content = [
    { text: condominium.name, style: 'header' },
    {
      text:
        assembly.type === 'meeting'
          ? 'Reunião'
          : `Assembleia ${assembly.type === 'extraordinary' ? 'extraordinária' : 'Ordinária'}`,
      style: 'subHeader',
    },
    {
      text: assembly.openingDate ? `Abertura: ${format(assembly.openingDate, 'DD/MM/YYYY HH:mm')}` : '',
    },
    {
      text: assembly.endDate ? `Encerramento: ${format(assembly.endDate, 'DD/MM/YYYY HH:mm')}` : '',
    },
    { text: `Síndico: ${me.name}`, margin: [0, 10, 0, 8] },
    {
      text: assembly.description,
      margin: [0, 10, 0, 8],
    },
  ];

  assembly.subjects.forEach(item => {
    const body = [
      [
        { text: 'Nome', style: 'tableHeader' },
        { text: 'Unidade', style: 'tableHeader' },
        { text: 'Voto', style: 'tableHeader' },
        { text: 'Assinatura', style: 'tableHeader' },
      ],
    ];

    item.options.forEach(element => {
      element.votes.forEach(vote => {
        const userData = getUserData(vote, condominium);
        if (userData) {
          body.push([vote.name, userData.unity, element.description, '']);
        }
      });
    });

    content.push({
      table: {
        headerRows: 1,

        widths: [497],
        body: [
          [
            {
              text: `${item.title} \n\n ${item.description}`,
              style: 'subjectHeader',
            },
          ],
        ],
      },
      layout: { fillColor: '#C4C4C4' },
    });
    content.push({
      table: {
        headerRows: 1,
        widths: [125, 80, 130, 135],

        body,
        layout: 'lightHorizontalLines',
      },
    });
    content.push({ text: '', margin: [20, 20, 20, 10] });
  });
  const docDefinition = {
    content,
    styles: {
      tableHeader: { bold: true },
      header: {
        fontSize: 18,
        bold: true,
        margin: [0, 0, 0, 10],
      },
      subHeader: {
        margin: [0, 0, 0, 8],
      },
    },
  };
  pdfMake.createPdf(docDefinition).download();
};
export const generateCommentsPDF = ({ assembly, condominium, me }) => {
  const content = [
    { text: condominium.name, style: 'header' },
    {
      text:
        assembly.type === 'meeting'
          ? 'Reunião'
          : `Assembleia ${assembly.type === 'extraordinary' ? 'extraordinária' : 'Ordinária'}`,
      style: 'subHeader',
    },
    {
      text: assembly.openingDate ? `Abertura: ${format(assembly.openingDate, 'DD/MM/YYYY HH:mm')}` : '',
    },
    {
      text: assembly.endDate ? `Encerramento: ${format(assembly.endDate, 'DD/MM/YYYY HH:mm')}` : '',
    },
    { text: `Síndico: ${me.name}`, margin: [0, 10, 0, 8] },
    {
      text: assembly.description,
      margin: [0, 10, 0, 8],
    },
  ];
  assembly.subjects.forEach(item => {
    const body = [
      [
        { text: 'Nome', style: 'tableHeader' },
        { text: 'Unidade', style: 'tableHeader' },
        { text: 'Texto', style: 'tableHeader' },
        { text: 'Assinatura', style: 'tableHeader' },
      ],
    ];

    item.comments.forEach(element => {
      const userData = getUserData(element.user, condominium);
      if (userData) {
        body.push([
          element.user.name,
          userData.unity,
          `${format(element.createdAt, 'DD/MM/YYYY HH:mm')} \n\n ${element.text}`,
          '',
        ]);

        if (element.replies && element.replies.length) {
          body.push([{ text: 'Resposta(s) do comentário:', style: 'tableHeader' }, '', '', '']);
          element.replies.forEach(reply => {
            const userReply = getUserData(element.user, condominium);
            if (userReply) {
              body.push([
                reply.user.name,
                userReply.unity,
                `${reply.createdAt ? `${format(reply.createdAt, 'DD/MM/YYYY HH:mm')} \n\n` : ''} ${reply.text}`,
                '',
              ]);
            }
          });
          body.push([{ text: 'Fim da(s) resposta(s)', style: 'tableHeader' }, '', '', '']);
        }
      }
    });

    content.push({
      table: {
        headerRows: 1,

        widths: [497],
        body: [
          [
            {
              text: `${item.title} \n\n ${item.description}`,
              style: 'subjectHeader',
            },
          ],
        ],
      },
      layout: { fillColor: '#C4C4C4' },
    });
    content.push({
      table: {
        headerRows: 1,
        widths: [125, 80, 130, 135],

        body,
        layout: 'lightHorizontalLines',
      },
    });
    content.push({ text: '', margin: [20, 20, 20, 10] });
  });
  const docDefinition = {
    content,
    styles: {
      tableHeader: { bold: true },
      header: {
        fontSize: 18,
        bold: true,
        margin: [0, 0, 0, 10],
      },
      subHeader: {
        margin: [0, 0, 0, 8],
      },
    },
  };

  pdfMake.createPdf(docDefinition).download();
};
